import React, { ReactNode } from 'react'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Split } from 'lucide-react'
import { CompanyEntity, CompanyShare, ShareCapitalChange, ShareSplit } from 'types/CompanyEntity'
import { flagPath } from '../../../../components/entities/CompaniesGrid'
import { normalizedName } from '../../../../components/entities/CompanyName'
import { FactsTable, FactsTableRow } from '../../../components/FactsTable'

const ValueContainer = ({ children }: { children: ReactNode }) => (
    <div style={{ paddingLeft: '16px', paddingTop: '1px', paddingBottom: '1px' }}>{children}</div>
)

export const SplitSummary = ({
    company,
    selectedShare,
    shareCapitalChange,
}: {
    company: Pick<CompanyEntity, 'countryCode'>
    selectedShare: CompanyShare
    shareCapitalChange: ShareCapitalChange
}) => {
    const companyLabel = (
        <Stack
            direction='row'
            spacing={2}
            sx={{
                alignItems: 'center',
            }}
        >
            {company.countryCode && (
                <Tooltip title={company.countryCode}>
                    <div style={{ display: 'inline-block' }}>
                        <img src={flagPath(company.countryCode)} width={25} style={{ display: 'block' }} />
                    </div>
                </Tooltip>
            )}
            {selectedShare.instrumentName && <Typography>{normalizedName(selectedShare.instrumentName)}</Typography>}
        </Stack>
    )
    const label = shareCapitalChange.type === 'split' ? 'Aktiesplit' : 'Fondemission'

    return (
        <Box sx={{ padding: 4 }}>
            <FactsTable isSlim>
                <FactsTableRow label={null} leftColumnWidth={null} rightColumnWidth={null}>
                    <Box>{companyLabel}</Box>
                    <Box sx={{ paddingTop: 2 }}>{label}</Box>
                </FactsTableRow>

                <FactsTableRow label={null} rightColumnWidth={null}>
                    <FactsTable noBorder>
                        <FactsTableRow
                            padding='2px 0px'
                            label={
                                <Tooltip title={label}>
                                    <Split size={16} />
                                </Tooltip>
                            }
                            leftColumnWidth={null}
                            rightColumnWidth={null}
                        >
                            <ValueContainer>
                                {shareCapitalChange.newShares}:{shareCapitalChange.oldShares}
                            </ValueContainer>
                        </FactsTableRow>
                        <FactsTableRow
                            padding='2px 0px'
                            label={
                                <Tooltip title={'Ändringsdatum'}>
                                    <CalendarMonthOutlinedIcon fontSize='small' />
                                </Tooltip>
                            }
                            leftColumnWidth={null}
                            rightColumnWidth={null}
                        >
                            <ValueContainer>
                                <>{shareCapitalChange.changeDate}</>
                            </ValueContainer>
                        </FactsTableRow>
                    </FactsTable>
                </FactsTableRow>
            </FactsTable>
        </Box>
    )
}
